import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

function Loading() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-white">
      <div className="flex items-center gap-3 text-slate-500">
        <span className="h-2.5 w-2.5 animate-pulse rounded-full bg-cargodash-primary-600" />
        <span className="text-sm font-medium tracking-wide">Checking session…</span>
      </div>
    </div>
  );
}

export default function RequireAuth({ children, perm }) {
  const { user, isLoading, hasPerm } = useAuth();
  const location = useLocation();
  if (isLoading) return <Loading />;
  if (!user) {
    return (
      <Navigate
        to="/login"
        replace
        state={{ from: location.pathname + location.search }}
      />
    );
  }
  if (perm && !hasPerm(perm)) {
    return <Navigate to="/" replace />;
  }
  return children;
}
